import {
  required,
  email,
  maxLength
} from 'vuelidate/lib/validators'
export default {
  email: {
    required,
    email
  },
  text: {
    required
  },
  number: {
    required,
    maxLength: maxLength(3)
  },
  textArea: {
    required
  },
  select: {
    required
  },
  dateTime: {
    required
  },
  date: {
    required
  },
  file: {
    required
  }
}
